import { styled } from '@mui/material';
import { motion } from 'framer-motion';
import { Link as AppLink } from 'react-router-dom';

import Icon from '../Icon/Icon';

export const Menu = styled('div', {
  shouldForwardProp: (prop) => prop !== 'isOpen',
})(({ theme, isOpen }) => ({
  position: 'fixed',
  zIndex: 40,
  top: 0,
  left: 0,
  width: '100%',
  height: ' 100%',
  display: 'flex',
  flexDirection: 'column',
  justifyContent: 'center',
  alignItems: 'center',
  backgroundColor: theme.palette.color.global.primary,
  opacity: isOpen ? '1' : '0',
  visibility: isOpen ? 'visible' : 'hidden',
  transition: 'all 0.3s ease-in-out',
}));

export const Container = styled('div')(({ theme }) => ({
  position: 'relative',
  display: 'flex',
  flexDirection: 'column',
  gap: '40px',
  width: '100%',
  maxWidth: '1388px',
  height: '100%',
  padding: '170px 30px 0',
  margin: '0 auto',

  [theme.breakpoints.down('md')]: {
    padding: '132px 20px 0',
  },
  [theme.breakpoints.down('sm')]: {
    padding: '110px 16px 0',
  },
}));

export const Buttons = styled('div')(({ theme }) => ({
  display: 'none',
  justifyContent: 'center',
  gap: '12px',

  [theme.breakpoints.down('md')]: {
    display: 'flex',
  },
}));

export const Links = styled(motion.div)(() => ({
  position: 'relative',
  zIndex: '1',
  display: 'flex',
  flexDirection: 'column',
  textAlign: 'center',
  gap: '40px',
  width: '100%',
}));

export const Link = styled(motion.create(AppLink), {
  shouldForwardProp: (prop) => prop !== 'isLinkActive',
})(({ theme, isLinkActive }) => ({
  display: 'inline-block',
  fontSize: '44px',
  fontWeight: 600,
  lineHeight: 1.4,
  pointerEvents: isLinkActive ? 'none' : 'auto',
  willChange: 'transform',

  [theme.breakpoints.down('md')]: {
    fontSize: '32px',
  },
  [theme.breakpoints.down('sm')]: {
    fontSize: '24px',
  },
}));

export const Logo = styled(Icon)(({ theme }) => ({
  position: 'absolute',
  left: '30px',
  bottom: '40px',
  width: 'calc(100% - 60px)',
  height: 'auto',
  aspectRatio: '110 / 32',
  color: theme.palette.color.grey.dark16,

  [theme.breakpoints.down('md')]: {
    left: '20px',
    bottom: '20px',
    width: 'calc(100% - 40px)',
  },

  [theme.breakpoints.down('sm')]: {
    left: '16px',
    width: 'calc(100% - 32px)',
  },
}));
